var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fade-in-fwd text-center", attrs: { id: "#step-4" } },
    [
      _c(
        "div",
        { staticClass: "mt-3 mb-4" },
        _vm._l(_vm.tabs, function(tab) {
          return _c(
            "button",
            {
              key: tab.label,
              staticClass: "btn btn-tab btn-tab-sm ml-2 mr-2",
              class: _vm.selectedTab == tab.value ? "active selected-tab" : "",
              on: {
                click: function($event) {
                  return _vm.handleTabChange(tab.value)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(tab.label) + "\n    ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectedTab === "Gallery",
              expression: "selectedTab === 'Gallery'"
            }
          ]
        },
        [
          _vm.images.length > 0
            ? _c(
                "div",
                { staticClass: "row mt-2" },
                _vm._l(_vm.images, function(image) {
                  return _c(
                    "div",
                    { key: image.embedId, staticClass: "col-sm-4" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "swiper-slide swiper-slide-visible swiper-slide-active mb-2",
                          class:
                            image.embedId == _vm.roomSceneId
                              ? "my-project-feature-image-active"
                              : "",
                          on: {
                            click: function($event) {
                              return _vm.updateImage(
                                image.embedId,
                                _vm.gallery,
                                image.imageAltText
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "wf-product-quick-view-swatch-slide"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "wf-product-quick-view-swatch-slide-image"
                                },
                                [
                                  _c("img", {
                                    staticClass: "room-img-thumb",
                                    attrs: {
                                      src: _vm.getImageUrl(
                                        image.embedId,
                                        500,
                                        _vm.gallery
                                      ),
                                      alt: image.imageAltText || ""
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showLoadMore
            ? _c("pc-load-more", { attrs: { "load-more": _vm.onLoadMore } })
            : !_vm.showLoadMore && _vm.images.length == 0
            ? _c("div", { staticClass: "container text-center mt-5 mb-5" }, [
                _c("p", {}, [
                  _vm._v(
                    _vm._s(_vm.$resourceString["common.NoDataAvailable.Msg"])
                  )
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectedTab === "Room",
              expression: "selectedTab === 'Room'"
            }
          ]
        },
        [
          _c(
            "div",
            { staticClass: "swatch-image-section row" },
            [
              _c("div", { staticClass: "col-md-12 text-justify" }, [
                _c(
                  "label",
                  {
                    staticClass: "font-weight-bold font-16 text-uppercase",
                    attrs: { for: "choose_color" }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$resourceString[
                          "myProject.Product.SelectColor.Label"
                        ]
                      )
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.getContentWizardData.step3, function(color) {
                return _c(
                  "div",
                  {
                    key: color.id,
                    staticClass: "col-2 swatch-image-item px-2 mt-2"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn wf-product-room-scene-color-item-button",
                        class:
                          color.colorNumber == _vm.selectedColorNumber
                            ? "wf-product-room-scene-color-item-button-active"
                            : "wf-product-room-scene-color-item-button-disabled",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.updateColor(color)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "w-100 h-100",
                          attrs: { src: color.imageLink, alt: "" }
                        })
                      ]
                    )
                  ]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.installationMethod && _vm.installationMethod != "default"
            ? _c("div", { staticClass: "swatch-image-section row mt-2 mb-2" }, [
                _c("div", { staticClass: "col-md-12 text-justify" }, [
                  _c(
                    "label",
                    {
                      staticClass: "font-weight-bold font-16 text-uppercase",
                      attrs: { for: "installation" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$resourceString[
                            "myProject.Product.InstallationMethod.Label"
                          ]
                        )
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.installationMethod,
                          expression: "installationMethod"
                        }
                      ],
                      staticClass:
                        "form-control form-control-sm text-uppercase",
                      attrs: {
                        name: "productType",
                        id: _vm.installationMethod,
                        required: "required"
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.installationMethod = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.handleInstallation
                        ]
                      }
                    },
                    _vm._l(_vm.getSelectedProduct.installationMethods, function(
                      item,
                      index
                    ) {
                      return _c(
                        "option",
                        {
                          key: index,
                          staticClass: "dropdown-item",
                          domProps: { value: item.name }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.name) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.step4.length > 0
            ? _c(
                "div",
                { staticClass: "row mt-2" },
                _vm._l(_vm.step4, function(item, index) {
                  return _c("div", { key: index, staticClass: "col-sm-4" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "swiper-slide swiper-slide-visible swiper-slide-active mb-2",
                        class:
                          item == _vm.roomSceneId
                            ? "my-project-feature-image-active"
                            : "",
                        on: {
                          click: function($event) {
                            return _vm.updateImage(item, null, "")
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "wf-product-quick-view-swatch-slide" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "wf-product-quick-view-swatch-slide-image"
                              },
                              [
                                _c("img", {
                                  staticClass: "room-img-thumb",
                                  attrs: {
                                    src: _vm.getImageUrl(item, 1000, null),
                                    alt: ""
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                }),
                0
              )
            : _c("div", { staticClass: "container text-center mt-5" }, [
                _c("p", {}, [
                  _vm._v(
                    _vm._s(_vm.$resourceString["common.NoDataAvailable.Msg"])
                  )
                ])
              ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectedTab === "Swatches",
              expression: "selectedTab === 'Swatches'"
            }
          ]
        },
        [
          _vm.getContentWizardData.step3.length > 0
            ? _c(
                "div",
                { staticClass: "row mt-2" },
                _vm._l(_vm.getContentWizardData.step3, function(color) {
                  return _c("div", { key: color.id, staticClass: "col-sm-4" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "swiper-slide swiper-slide-visible swiper-slide-active mb-2",
                        class:
                          color.imageLink == _vm.imgUrl
                            ? "my-project-feature-image-active"
                            : "",
                        on: {
                          click: function($event) {
                            return _vm.updateSwatchesImage(color)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "wf-product-quick-view-swatch-slide" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "wf-product-quick-view-swatch-slide-image"
                              },
                              [
                                _c("img", {
                                  staticClass: "room-img-thumb",
                                  attrs: { src: color.imageLink, alt: "" }
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                }),
                0
              )
            : _c("div", { staticClass: "container text-center mt-5" }, [
                _c("p", {}, [
                  _vm._v(
                    _vm._s(_vm.$resourceString["common.NoDataAvailable.Msg"])
                  )
                ])
              ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }